import { supabase } from '../integrations/supabase/client';

interface SecureConfig {
  openaiApiKey?: string;
  stripePublishableKey?: string;
  googleMapsApiKey?: string;
}

class SecureConfigService {
  private config: SecureConfig = {};
  private isInitialized = false;

  async initialize(): Promise<void> {
    if (this.isInitialized) return;

    try {
      // Fetch public, non-sensitive config via Supabase Edge Function
      const { data, error } = await supabase.functions.invoke('public-config');

      if (error) {
        console.warn('public-config error:', error);
        this.config = {};
      } else {
        this.config = (data as any) || {};
      }
    } catch (error) {
      console.warn('Failed to load secure config:', error);
      // Do not rely on environment variables in this app
      this.config = {};
    }
    
    this.isInitialized = true;
  }

  getConfig(key: keyof SecureConfig): string | undefined {
    return this.config[key];
  }

  isConfigured(key: keyof SecureConfig): boolean {
    return !!this.config[key];
  }

  // Set configuration value (for testing or manual configuration)
  setConfig(key: keyof SecureConfig, value: string): void {
    this.config[key] = value;
  }

  // Clear all configuration
  clearConfig(): void {
    this.config = {};
    this.isInitialized = false;
  }
}

export const secureConfigService = new SecureConfigService();
